<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <ValidationProvider name="semester" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('semester')">
                                    <semesters-selectbox v-model="defineForm.semester_id"
                                                         :validate-error="errors[0]" :setActive="true"
                                    />
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
<!--                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <b-form-group :label="$t('excel_format')">
                                <div class="alert alert-info">
                                    {{ $t('course_schedule_format') }}
                                </div>
                            </b-form-group>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <DownloadExcelTemplate :code="'course_schedules'"/>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component
import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox';

// Services
import CourseScheduleService from '@/services/CourseScheduleService';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import excelImportTemplate from "@/services/ExcelImportTemplate";
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";

export default {
    components: {
        DownloadExcelTemplate,
        SemestersSelectbox,

        ValidationProvider,
        ValidationObserver
    }
    ,
    data() {
        return {
            defineForm: {
                semester_id: null,
                file: null
            },
            loading: false,
        }
    }
    ,
    methods: {
        async sendForm() {
            const isValid = await this.$refs.updateForm.validate();

            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])

                return CourseScheduleService.dailyCourseScheduleImport(this.defineForm.semester_id, formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                    })
                    .catch(e => {
                        this.showErrors(e,this.$refs.updateForm)
                    })
            }
        },

    }
}
</script>
